export const CHECKED_ADDRESS = 'checkedAddress';
export const DEL_ADDRESS = 'delAddress';